import type { QueuedRecording, ResearchStorageAdapter, UploadResult } from '../types';

export class DisabledAdapter implements ResearchStorageAdapter {
  readonly id = 'disabled' as const;

  isEnabled(): boolean {
    return false;
  }

  upload(_item: QueuedRecording): Promise<UploadResult> {
    return Promise.reject(
      new Error('Research upload is disabled until VITE_RESEARCH_UPLOAD_URL is set')
    );
  }

  deleteParticipant(_participantId: string): Promise<void> {
    return Promise.resolve();
  }
}
